import { WEBSITE_ROOT_PATH, ECOMMERCE_ROOT_PATH } from './SectionSelect.constants';

export function getInitialRoute(location) {
  return location.pathname.includes('core') ? WEBSITE_ROOT_PATH : ECOMMERCE_ROOT_PATH;
}
